const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="copyright">
          © {new Date().getFullYear()} Elisa Gomez
        </p>
        <p className="made-with">
          Développé avec React & Framer Motion
        </p>
      </div>
    </footer>
  );
};

export default Footer;
